import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Link from './Link';
import matchPath from './matchPath';
import RouterContext from './RouterContext';
import { normalizeToLocation, resolveToLocation } from './utils/locationUtils'; // React 15 compat

var forwardRefShim = function (C) {
  return C;
};

var forwardRef = React.forwardRef;

if (typeof forwardRef === 'undefined') {
  forwardRef = forwardRefShim;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(' ');
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef(function (_ref, forwardedRef) {
  var _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? 'active' : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      _ref$ariaCurrent = _ref['aria-current'],
      ariaCurrent = _ref$ariaCurrent === void 0 ? 'page' : _ref$ariaCurrent,
      classNameProp = _ref.className,
      exact = _ref.exact,
      innerRef = _ref.innerRef,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = _objectWithoutProperties(_ref, ["activeClassName", "activeStyle", "aria-current", "className", "exact", "innerRef", "isActive", "location", "sensitive", "strict", "style", "to"]);

  return /*#__PURE__*/React.createElement(RouterContext.Consumer, null, function (context) {
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
    var match = escapedPath ? matchPath(currentLocation.pathname, {
      exact: exact,
      path: escapedPath,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? _objectSpread(_objectSpread({}, styleProp), activeStyle) : styleProp;

    var props = _objectSpread({
      'aria-current': isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/React.createElement(Link, props);
  });
});
export default NavLink;